import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-xxl-8" }
const _hoisted_3 = { class: "general-info mb-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 0,
  class: "col-4"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "company-contact-info mb-3" }
const _hoisted_16 = { class: "form-content" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-3" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "pharmacy-contact-info mb-4" }
const _hoisted_30 = { class: "form-check" }
const _hoisted_31 = ["errors"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  style: {"font-size":"13px"},
  for: "flexRadioDefault1"
}, " Zelfde gegevens ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "form-help" }, "Mijn vennootschap en publieke apotheek hebben dezelfde contactgegevens.", -1)
const _hoisted_34 = { class: "form-check" }
const _hoisted_35 = ["errors"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  style: {"font-size":"13px"},
  for: "flexRadioDefault2"
}, " Andere gegevens ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "form-help" }, "Mijn vennootschap en publieke apotheek hebben verschillende contactgegevens.", -1)
const _hoisted_38 = {
  key: 0,
  class: "form-content pt-4"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-3" }
const _hoisted_47 = { class: "col" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "col" }
const _hoisted_51 = {
  key: 0,
  class: "socials my-4"
}
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col" }
const _hoisted_57 = { class: "col" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "col" }
const _hoisted_61 = { class: "buttons d-flex flex-column justify-content-start" }
const _hoisted_62 = { class: "d-inline-block mt-4 pt-4 border-top border-2 border-light" }
const _hoisted_63 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError = _resolveComponent("AlertError")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_i18n_input_text = _resolveComponent("i18n-input-text")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_input_email = _resolveComponent("input-email")!
  const _component_input_url = _resolveComponent("input-url")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('pharmacyData'),
        "help-text": this.getHelp,
        "show-refresh-button": "",
        onRefresh: this.reloadContent
      }, null, 8, ["title", "help-text", "onRefresh"]),
      _createVNode(_component_AlertError, {
        exceptions: this.exceptions,
        class: "mt-3"
      }, null, 8, ["exceptions"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BaseSpinner, {
            spin: !this.isReady
          }, null, 8, ["spin"]),
          (this.isReady)
            ? (_openBlock(), _createBlock(_component_dp_form, {
                key: 0,
                as: "form",
                onSubmit: _ctx.submitData,
                onInvalidSubmit: _ctx.onInvalidSubmit,
                novalidate: ""
              }, {
                default: _withCtx(({ errors }) => [
                  _createVNode(_component_MultilingualSwitcher, {
                    errors: errors,
                    "active-language": this.activeLanguage,
                    onUpdateActiveLanguage: _cache[0] || (_cache[0] = newValue => this.activeLanguage = newValue)
                  }, null, 8, ["errors", "active-language"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_i18n_input_text, {
                          label: _ctx.$t('publicPharmacyName'),
                          "active-language": this.activeLanguage,
                          errors: errors,
                          data: _ctx.pharmacy_info.public_name,
                          "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pharmacy_info.public_name) = $event)),
                          name: "public_name",
                          placeholder: "public_name",
                          rules: "required|max:100"
                        }, null, 8, ["label", "active-language", "errors", "data"])
                      ]),
                      (_ctx.AbilityContext.isAuthorizedForFeature('CUSTOM_HEADER_STACK'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_i18n_input_text, {
                              label: _ctx.$t('publicPharmacyNameShort'),
                              "active-language": this.activeLanguage,
                              errors: errors,
                              data: _ctx.pharmacy_info.public_name_short,
                              "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pharmacy_info.public_name_short) = $event)),
                              name: "public_name_short",
                              placeholder: "public_name_short",
                              rules: "max:100"
                            }, null, 8, ["label", "active-language", "errors", "data"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_i18n_input_text, {
                          label: _ctx.$t('companyName'),
                          "active-language": this.activeLanguage,
                          errors: errors,
                          data: _ctx.pharmacy_info.company_name,
                          "onUpdate:data": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pharmacy_info.company_name) = $event)),
                          name: "company_name",
                          placeholder: "company_name",
                          rules: "required|max:100"
                        }, null, 8, ["label", "active-language", "errors", "data"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_input_text, {
                          modelValue: _ctx.pharmacy_info.vat_number,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pharmacy_info.vat_number) = $event)),
                          label: _ctx.$t('vatNumber'),
                          placeholder: "vatNumber",
                          name: "vatNumber",
                          rules: "max:20",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_input_text, {
                          modelValue: _ctx.pharmacy_info.rpr,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pharmacy_info.rpr) = $event)),
                          label: _ctx.$t('rpr'),
                          placeholder: "rpr",
                          name: "rpr",
                          rules: "max:100",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_input_text, {
                          modelValue: _ctx.pharmacy_info.apb_number,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pharmacy_info.apb_number) = $event)),
                          label: _ctx.$t('apbNumber'),
                          placeholder: "apbNumber",
                          name: "apbNumber",
                          rules: "required|max:20",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_i18n_input_text, {
                          label: _ctx.$t('titular'),
                          "active-language": this.activeLanguage,
                          errors: errors,
                          data: _ctx.pharmacy_info.pharmacy_holder_name,
                          "onUpdate:data": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pharmacy_info.pharmacy_holder_name) = $event)),
                          name: "pharmacy_holder_name",
                          placeholder: "pharmacy_holder_name",
                          rules: "max:100"
                        }, null, 8, ["label", "active-language", "errors", "data"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Subtitle, {
                      title: _ctx.$t('companyContactInfo')
                    }, null, 8, ["title"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_i18n_input_text, {
                            label: _ctx.$t('street'),
                            "active-language": this.activeLanguage,
                            errors: errors,
                            data: _ctx.pharmacy_info.company_address.street,
                            "onUpdate:data": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pharmacy_info.company_address.street) = $event)),
                            name: "company_street",
                            placeholder: "company_street",
                            rules: "required|max:100"
                          }, null, 8, ["label", "active-language", "errors", "data"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_input_text, {
                            modelValue: _ctx.pharmacy_info.company_address.house_number,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pharmacy_info.company_address.house_number) = $event)),
                            label: _ctx.$t('houseNr'),
                            placeholder: "companyHouseNr",
                            name: "companyHouseNr",
                            rules: "required|max:20",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_input_text, {
                            modelValue: _ctx.pharmacy_info.company_address.box,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pharmacy_info.company_address.box) = $event)),
                            label: _ctx.$t('box'),
                            placeholder: "companyBox",
                            name: "companyBox",
                            rules: "max:10",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_i18n_input_text, {
                            label: _ctx.$t('extraAddress'),
                            "active-language": this.activeLanguage,
                            errors: errors,
                            data: _ctx.pharmacy_info.company_address.extra_address_line,
                            "onUpdate:data": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pharmacy_info.company_address.extra_address_line) = $event)),
                            name: "company_extra_address",
                            placeholder: "company_extra_address",
                            rules: "max:100"
                          }, null, 8, ["label", "active-language", "errors", "data"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_input_text, {
                            modelValue: _ctx.pharmacy_info.company_address.postal_code,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pharmacy_info.company_address.postal_code) = $event)),
                            label: _ctx.$t('postalCode'),
                            placeholder: "companyPostalCode",
                            name: "companyPostalCode",
                            rules: "required|max:10",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_i18n_input_text, {
                            label: _ctx.$t('city'),
                            "active-language": this.activeLanguage,
                            errors: errors,
                            data: _ctx.pharmacy_info.company_address.city_name,
                            "onUpdate:data": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.pharmacy_info.company_address.city_name) = $event)),
                            name: "company_city_name",
                            placeholder: "company_city_name",
                            rules: "required|max:100"
                          }, null, 8, ["label", "active-language", "errors", "data"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_input_text, {
                            modelValue: _ctx.pharmacy_info.company_phone,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pharmacy_info.company_phone) = $event)),
                            label: _ctx.$t('telephone'),
                            placeholder: "companyTelephone",
                            name: "companyTelephone",
                            rules: "required|max:20",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_input_email, {
                            modelValue: _ctx.pharmacy_info.company_email,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pharmacy_info.company_email) = $event)),
                            label: _ctx.$t('emailAddress'),
                            placeholder: "companyEmail",
                            name: "companyEmail",
                            rules: "required|max:200",
                            errors: errors
                          }, null, 8, ["modelValue", "label", "errors"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Subtitle, {
                      title: _ctx.$t('pharmacyContactInfo'),
                      mb: "3"
                    }, null, 8, ["title"]),
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "flexRadioDefault",
                        id: "flexRadioDefault1",
                        value: false,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.pharmacy_info.different_contactinfo) = $event)),
                        errors: errors
                      }, null, 8, _hoisted_31), [
                        [_vModelRadio, _ctx.pharmacy_info.different_contactinfo]
                      ]),
                      _hoisted_32,
                      _hoisted_33
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "flexRadioDefault",
                        id: "flexRadioDefault2",
                        value: true,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.pharmacy_info.different_contactinfo) = $event)),
                        errors: errors
                      }, null, 8, _hoisted_35), [
                        [_vModelRadio, _ctx.pharmacy_info.different_contactinfo]
                      ]),
                      _hoisted_36,
                      _hoisted_37
                    ]),
                    (_ctx.pharmacy_info.different_contactinfo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_i18n_input_text, {
                                label: _ctx.$t('street'),
                                "active-language": this.activeLanguage,
                                errors: errors,
                                data: _ctx.pharmacy_info.public_address.street,
                                "onUpdate:data": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.pharmacy_info.public_address.street) = $event)),
                                name: "public_street",
                                placeholder: "public_street",
                                rules: "required|max:100"
                              }, null, 8, ["label", "active-language", "errors", "data"])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_input_text, {
                                modelValue: _ctx.pharmacy_info.public_address.house_number,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.pharmacy_info.public_address.house_number) = $event)),
                                label: _ctx.$t('houseNr'),
                                placeholder: "publicHouseNr",
                                name: "publicHouseNr",
                                rules: "required|max:20",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_input_text, {
                                modelValue: _ctx.pharmacy_info.public_address.box,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.pharmacy_info.public_address.box) = $event)),
                                label: _ctx.$t('box'),
                                placeholder: "publicBox",
                                name: "publicBox",
                                rules: "max:10",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_i18n_input_text, {
                                label: _ctx.$t('extraAddress'),
                                "active-language": this.activeLanguage,
                                errors: errors,
                                data: _ctx.pharmacy_info.public_address.extra_address_line,
                                "onUpdate:data": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.pharmacy_info.public_address.extra_address_line) = $event)),
                                name: "public_extra_address",
                                placeholder: "public_extra_address",
                                rules: "max:100"
                              }, null, 8, ["label", "active-language", "errors", "data"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_input_text, {
                                modelValue: _ctx.pharmacy_info.public_address.postal_code,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.pharmacy_info.public_address.postal_code) = $event)),
                                label: _ctx.$t('postalCode'),
                                placeholder: "publicPostalCode",
                                name: "publicPostalCode",
                                rules: "required|max:10",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createVNode(_component_i18n_input_text, {
                                label: _ctx.$t('city'),
                                "active-language": this.activeLanguage,
                                errors: errors,
                                data: _ctx.pharmacy_info.public_address.city_name,
                                "onUpdate:data": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.pharmacy_info.public_address.city_name) = $event)),
                                name: "public_city_name",
                                placeholder: "public_city_name",
                                rules: "required|max:100"
                              }, null, 8, ["label", "active-language", "errors", "data"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createVNode(_component_input_text, {
                                modelValue: _ctx.pharmacy_info.public_phone,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.pharmacy_info.public_phone) = $event)),
                                label: _ctx.$t('telephone'),
                                placeholder: "publicTelephone",
                                name: "publicTelephone",
                                rules: "required|max:20",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createVNode(_component_input_email, {
                                modelValue: _ctx.pharmacy_info.public_email,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.pharmacy_info.public_email) = $event)),
                                label: _ctx.$t('emailAddress'),
                                placeholder: "publicEmail",
                                name: "publicEmail",
                                rules: "required|max:200",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.$can('use-feature', 'MGMT_PHARMACY_DATA_SOCIAL_MEDIA'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createVNode(_component_Subtitle, {
                          title: _ctx.$t('socialMedia'),
                          subtitle: "Plaats de volledige link, inclusief https://"
                        }, null, 8, ["title"]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_input_url, {
                              modelValue: _ctx.pharmacy_info.link_to_facebook,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.pharmacy_info.link_to_facebook) = $event)),
                              label: _ctx.$t('linkFacebook'),
                              name: "linkToFacebook",
                              rules: "max:200",
                              errors: errors
                            }, null, 8, ["modelValue", "label", "errors"])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_input_url, {
                              modelValue: _ctx.pharmacy_info.link_to_instagram,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.pharmacy_info.link_to_instagram) = $event)),
                              label: _ctx.$t('linkInstagram'),
                              name: "linkToInstagram",
                              rules: "max:200",
                              errors: errors
                            }, null, 8, ["modelValue", "label", "errors"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_input_url, {
                              modelValue: _ctx.pharmacy_info.link_to_whatsapp,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.pharmacy_info.link_to_whatsapp) = $event)),
                              label: _ctx.$t('linkWhatsapp'),
                              name: "linkToWhatsapp",
                              rules: "max:200",
                              errors: errors
                            }, null, 8, ["modelValue", "label", "errors"])
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(_component_input_url, {
                              modelValue: _ctx.pharmacy_info.link_to_twitter,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.pharmacy_info.link_to_twitter) = $event)),
                              label: _ctx.$t('linkTwitter'),
                              name: "linkToTwitter",
                              rules: "max:200",
                              errors: errors
                            }, null, 8, ["modelValue", "label", "errors"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_input_url, {
                              modelValue: _ctx.pharmacy_info.link_to_linkedin,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.pharmacy_info.link_to_linkedin) = $event)),
                              label: _ctx.$t('linkLinkedin'),
                              name: "linkToLinkedin",
                              rules: "max:200",
                              errors: errors
                            }, null, 8, ["modelValue", "label", "errors"])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_input_url, {
                              modelValue: _ctx.pharmacy_info.link_to_youtube,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.pharmacy_info.link_to_youtube) = $event)),
                              label: _ctx.$t('linkYoutube'),
                              name: "linkToYoutube",
                              rules: "max:200",
                              errors: errors
                            }, null, 8, ["modelValue", "label", "errors"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("button", _hoisted_63, _toDisplayString(_ctx.$t('save')), 1),
                      _createVNode(_component_router_link, {
                        class: "ms-3 btn btn-outline-primary",
                        to: "/"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "onInvalidSubmit"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}